/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Studio_KickerInputs */

const cs_builder_studio_kicker = /** @type {(inputs: Builder_Studio_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor šablon`)
};

const en_builder_studio_kicker = /** @type {(inputs: Builder_Studio_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template builder`)
};

/**
* | output |
* | --- |
* | "Template builder" |
*
* @param {Builder_Studio_KickerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_studio_kicker = /** @type {((inputs?: Builder_Studio_KickerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Studio_KickerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_studio_kicker(inputs)
	return cs_builder_studio_kicker(inputs)
});